import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWorkflowOverviewSearch = defineStore(
  'workflowOverviewSearch',
  () => {
    const focusedAt = ref<number | undefined>(undefined)
    const searchTerm = ref('')
    const isActive = ref(false)
    const hasHeaderSearch = ref(false)

    function focusSearch(): void {
      focusedAt.value = Date.now()
    }

    function clearSearch(): void {
      searchTerm.value = ''
    }

    function searchFor(term: string): void {
      searchTerm.value = term
    }

    function openSearch(): void {
      isActive.value = true
      focusSearch()
    }

    function closeSearch(): void {
      isActive.value = false
      clearSearch()
    }

    function toggleSearch(): void {
      if (isActive.value) {
        closeSearch()
      } else {
        openSearch()
      }
    }

    function registerHeaderSearch(): void {
      hasHeaderSearch.value = true
    }

    function unregisterHeaderSearch(): void {
      hasHeaderSearch.value = false
    }

    return {
      clearSearch,
      closeSearch,
      focusedAt,
      focusSearch,
      hasHeaderSearch,
      isActive,
      openSearch,
      registerHeaderSearch,
      searchFor,
      searchTerm,
      toggleSearch,
      unregisterHeaderSearch,
    }
  }
)
